import { createAuthService } from './authServiceFactory';

export default createAuthService('invoice-portal-token');
